/* Empty fallback module definition to get Vite to ignore unnecessary Node
 * polyfills referenced by sql.js */
export default {};

